<template>
  <div id="paginaImportaTracciatiBiglietteria">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card File Upload:  -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Importazione Tracciati Biglietteria</b-card-title>
              <b-card-text class="mb-0">
                Teatro Coccia
              </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#">
                ...
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <!-- Input di tipo testo: annotazione  -->
              <b-col xl="12" md="12" class="mb-2">
                <label for="annotazione" class="h5">Annotazione</label>
                <ejs-textbox id="annotazione" v-model="annotazione" floatLabelType="Never" cssClass=""
                  placeholder="Annotazione" showClearButton="true" type="text" autocomplete="false" />
              </b-col>
              <!-- Input di tipo file uploader multiplo: tracciati biglietteria -->
              <b-col xl="12" md="12" class="pt-1">
                <label for="fileInput" class="h5">Seleziona uno o piu file tracciati di biglietteria</label>
                <ejs-uploader ref="fileUploader" id='fileUploader' name="fileUploader" :asyncSettings="fileUploaderPath"
                  :removing="addJWTHeaders" :autoUpload="false" :uploading="onFileUpload" :buttons="buttons"
                              :success="actionComplete"></ejs-uploader>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
import {
  AlertPlugin,
  CardPlugin,
  DropdownPlugin,
  LayoutPlugin,
} from 'bootstrap-vue'

import { TextBoxPlugin, UploaderPlugin } from '@syncfusion/ej2-vue-inputs'

// use bootstrap-vue
Vue.use(AlertPlugin)
Vue.use(CardPlugin)
Vue.use(DropdownPlugin)
Vue.use(LayoutPlugin)
// use Syncfusion
Vue.use(TextBoxPlugin)
Vue.use(UploaderPlugin)

export default {
  data() {
    return {
      d: [],
      annotazione: "File caricato manualmente",
      dataCaricamento: null,
      buttonState: false,
      fileUploaderPath: {
        saveUrl: process.env.VUE_APP_API_ENDPOINT + '/demo/api/tracciati/upload',
        removeUrl: process.env.VUE_APP_API_ENDPOINT + '/demo/api/tracciati/remove', // ??Cosa fa removeUrl in un fileUploader??
      },
      buttons: { browse: "Seleziona File", clear: "Cancella", upload: "Processa" },
    }
  },
  methods: {
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      })
    },
    addJWTHeaders(args) {
      const token = useJwt.getToken()

      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', 'Bearer ' + token)
    },
    onFileUpload(args) {
      const token = useJwt.getToken()
      this.makeToast('primary', 'Info', 'Import Avviato')
      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', 'Bearer ' + token)

      args.customFormData = [{ annotazione: this.annotazione }]
    },
    actionComplete(args) {
      console.log(args)
      if (args.name === 'success') {
        console.log('tutto a posto')
        this.makeToast('primary', 'Info', 'Import eseguito correttamente')
        setTimeout(() => { this.$router.push('/') }, 1000)
      } else {
        // mostrare errori import
        this.makeToast('primary', 'Info', 'Import eseguito non correttamente')
      }
    },
  },
}
</script>
<style>
@import "~@syncfusion/ej2-base/styles/bootstrap.css";
@import "~@syncfusion/ej2-buttons/styles/bootstrap.css";
@import "~@syncfusion/ej2-vue-inputs/styles/bootstrap.css";
.control-section {
  height: 100%;
  min-height: 200px;
}

button:has(> span.prova)
{
  display: none;
}
</style>
